import axios from 'axios'
import router from '../../router/main'
import {handleError} from "../../common"

const state = {
    username: '',
    token: localStorage.getItem('user-token') || '',
    email: localStorage.getItem('user-email') || '',
    status: '',
    //id: 189,
    id: null,
    company: '',
    accountNumber: '',
    roles: []
};

const mutations = {
    setUser (state, user) {
        state.username = user.username;
        state.company = user.company;
        state.accountNumber = user.accountNumber;
        state.roles = user.roles
    },
    setStatus (state, status) {
        state.status = status;
    },
    setToken (state, token) {
        state.token = token;
    },
    setEditIndex(state, index) {
        state.editIndex = index;
        if (index > -1 && state.confidants[index].id ){
            state.backUpConfidant = Object.assign({}, state.confidants[index]);
        }
    },
    logOut (state, data) {
        state.token = data;
        state.email = data;
        localStorage.removeItem('user-token');
        localStorage.removeItem('user-email');
    },
    setEmail (state, email) {
        state.email = email;
    },
    setRoles (state, roles) {
        state.roles = roles;
    },
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
};

const actions = {
    authUser({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true, { root: true });
            axios.post('/api/login', params)
                .then((response) => {
                    if (response.data.success) {
                        localStorage.setItem('user-token', response.data.token);
                        commit('setToken', response.data.token);

                        localStorage.setItem('user-email', params.email);
                        commit('setEmail', params.email);
                        resolve();
                    } else {
                        reject(response.data.message);
                    }
                    commit('setLoading', false, { root: true });
                })
                .catch(() => {
                    commit('setLoading', false, { root: true });
                });

        });
    },
    logoutUser({commit, state}) {
        let config = {
            headers: { 'Authorization': `Bearer ${state.token}` }
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/logout', {}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('setToken', '');
                        commit('setEmail', '');

                        localStorage.removeItem('user-token');
                        localStorage.removeItem('user-email');
                        router.push({name: 'Login'});
                        resolve();
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(() => {
                });

        });
    },
    registerUser({commit}, params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/register', params)
                .then((response) => {
                    if (response.data.success) {
                        commit('setStatus', 'registered');
                        resolve(response.data.message);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(() => {
                });

        });
    },
    confirmRegistration({commit}, params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/register/confirm', params)
                .then((response) => {
                    if (response.data.success) {
                        commit('setStatus', 'confirmed');
                        localStorage.setItem('user-token', response.data.token);
                        commit('setToken', response.data.token);

                        localStorage.setItem('user-email', response.data.email);
                        commit('setEmail', response.data.email);
                        resolve(response.data.message);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(() => {
                });

        });
    },
    resetPassword({commit}, params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/restore-password/reset', params)
                .then((response) => {
                    if (response.data.success) {
                        commit('setStatus', 'reseted');
                        resolve(response.data.message);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(() => {
                });

        });
    },
    restorePassword({commit}, params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/restore-password', params)
                .then((response) => {
                    if (response.data.success) {
                        commit('setStatus', 'restore');
                        resolve(response.data.message);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch(() => {
                });
        });
    },

    getUserInfo({commit, state}) {
        let config = {
            headers: { 'Authorization': `Bearer ${state.token}` }
        };
        return new Promise((resolve) => {
            commit('setLoading', true, { root: true });
            setTimeout(() => axios.get('/api/user/info', config )
                .then((response) => {
                    if (response.data.success) {
                        commit('setUser', response.data.user);
                        resolve();
                    }
                    commit('setLoading', false, { root: true });
                })
                .catch((response) => {
                    commit('setFirstLoading', false, { root: true });
                    commit('setLoading', false, { root: true });
                    handleError(response, commit);
                    //this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                }), 0);
        });
    },
};

export default {
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}
